import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthService from './services/auth'
import store from './store/index'

/*
 |--------------------------------------------------------------------------
 | Admin Views
 |--------------------------------------------------------------------------|
 */

// Dashboard
import Ecommerce from './views/admin/dashboard/Ecommerce.vue'

// Layouts
import LayoutBasic from './views/layouts/LayoutBasic.vue'
import LayoutLogin from './views/layouts/LayoutLogin.vue'

// Settings
import Settings from './views/admin/Settings.vue'

/*
 |--------------------------------------------------------------------------
 | Other
 |--------------------------------------------------------------------------|
 */

// Blog
import BlogCategoriesList from './views/admin/blog/CategoriesList.vue'
import BlogCategoriesEdit from './views/admin/blog/CategoriesEdit.vue'
import BlogCategoriesCreate from './views/admin/blog/CategoriesCreate.vue'
import BlogRecordsList from './views/admin/blog/RecordsList.vue'
import BlogRecordsEdit from './views/admin/blog/RecordsEdit.vue'
import BlogRecordsCreate from './views/admin/blog/RecordsCreate.vue'
import PressList from './views/admin/press/PressList.vue'
import PressEdit from './views/admin/press/PressEdit.vue'
import PressCreate from './views/admin/press/PressCreate.vue'
import TeammatesList from './views/admin/teammates/TeammatesList.vue'
import TeammatesEdit from './views/admin/teammates/TeammatesEdit.vue'
import TeammatesCreate from './views/admin/teammates/TeammatesCreate.vue'
import TestimonialsList from './views/admin/testimonials/TestimonialsList.vue'
import TestimonialsEdit from './views/admin/testimonials/TestimonialsEdit.vue'
import TestimonialsCreate from './views/admin/testimonials/TestimonialsCreate.vue'
import CareersList from './views/admin/careers/CareersList.vue'
import CareersEdit from './views/admin/careers/CareersEdit.vue'
import CareersCreate from './views/admin/careers/CareersCreate.vue'
import CatalogueTypesList from './views/admin/products/CatalogueTypesList.vue'
import CatalogueTypesEdit from './views/admin/products/CatalogueTypesEdit.vue'
import CatalogueTypesCreate from './views/admin/products/CatalogueTypesCreate.vue'
import CatalogueProductsList from './views/admin/products/CatalogueProductsList.vue'
import CatalogueProductsEdit from './views/admin/products/CatalogueProductsEdit.vue'
import CatalogueProductsCreate from './views/admin/products/CatalogueProductsCreate.vue'
import CatalogueStrengthList from './views/admin/products/CatalogueStrenghtList.vue'
import CatalogueStrengthEdit from './views/admin/products/CatalogueStrenghtEdit.vue'
import CatalogueStrengthCreate from './views/admin/products/CatalogueStrenghtCreate.vue'
import CatalogueFlavorsList from './views/admin/products/CatalogueFlavorsList.vue'
import CatalogueFlavorsEdit from './views/admin/products/CatalogueFlavorsEdit.vue'
import CatalogueFlavorsCreate from './views/admin/products/CatalogueFlavorsCreate.vue'
import CatalogueDrugFormsList from './views/admin/products/CatalogueDrugFormsList.vue'
import CatalogueDrugFormsEdit from './views/admin/products/CatalogueDrugFormsEdit.vue'
import CatalogueDrugFormsCreate from './views/admin/products/CatalogueDrugFormsCreate.vue'
import PrescriptionsList from './views/admin/prescriptions/PrescriptionsList.vue'
import PrescriptionsCreate from './views/admin/prescriptions/PrescriptionsCreate.vue'
import PrescriptionsView from './views/admin/prescriptions/PrescriptionsView.vue'
import ProfilesList from './views/admin/profiles/ProfilesList.vue'
import ProfilesEdit from './views/admin/profiles/ProfilesEdit.vue'
import ProfilesCreate from './views/admin/profiles/ProfilesCreate.vue'
import UsersList from './views/admin/users/UsersList.vue'
import UsersEdit from './views/admin/users/UsersEdit.vue'
import UsersCreate from './views/admin/users/UsersCreate.vue'
import RolesList from './views/admin/users/RolesList.vue'
import RolesEdit from './views/admin/users/RolesEdit.vue'
import RolesCreate from './views/admin/users/RolesCreate.vue'
import SeoList from './views/admin/seo/SeoList.vue'
import SeoEdit from './views/admin/seo/SeoEdit.vue'
import BlogCategoriesSeoList from './views/admin/seo/CategoriesList.vue'
import BlogCategoriesSeoEdit from './views/admin/seo/CategoriesEdit.vue'
import BlogRecordsSeoList from './views/admin/seo/RecordsList.vue'
import BlogRecordsSeoEdit from './views/admin/seo/RecordsEdit.vue'
import CatalogueTypesSeoList from './views/admin/seo/CatalogueTypesList.vue'
import CatalogueTypesSeoEdit from './views/admin/seo/CatalogueTypesEdit.vue'
import CatalogueProductsSeoList from './views/admin/seo/CatalogueProductsList.vue'
import CatalogueProductsSeoEdit from './views/admin/seo/CatalogueProductsEdit.vue'
import FormsList from './views/admin/forms/FormsList.vue'
import FormsView from './views/admin/forms/FormsView.vue'
import TrashView from './views/admin/trash/TrashList.vue'
import ImagesSeoList from './views/admin/seo/SeoImageList.vue'
import ImagesSeoEdit from './views/admin/seo/SeoImageEdit.vue'
import PromoList from './views/admin/promo/PromoList.vue'
import PromoEdit from './views/admin/promo/PromoEdit.vue'
import PromoCreate from './views/admin/promo/PromoCreate.vue'

// Auth
import Login from './views/auth/Login.vue'

import NotFoundPage from './views/errors/404.vue'

/*
 |--------------------------------------------------------------------------
 | Frontend Views
 |--------------------------------------------------------------------------|
 */

Vue.use(VueRouter)

const routes = [
  /*
   |--------------------------------------------------------------------------
   | Admin Backend Routes
   |--------------------------------------------------------------------------|
   */
  {
    path: '/admin',
    component: LayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Dashboard
      {
        path: '/',
        redirect: '/admin/dashboard'
      },
      {
        path: 'dashboard',
        component: Ecommerce
      },

      // Blog
      {
        path: 'blog/categories',
        name: 'blog-categories',
        component: BlogCategoriesList
      },
      {
        path: 'blog/categories/:categoryId/edit',
        name: 'blog-category-edit',
        component: BlogCategoriesEdit
      },
      {
        path: 'blog/categories/create',
        name: 'blog-category-create',
        component: BlogCategoriesCreate
      },
      {
        path: 'blog/records',
        name: 'blog-records',
        component: BlogRecordsList
      },
      {
        path: 'blog/records/:recordId/edit',
        name: 'blog-record-edit',
        component: BlogRecordsEdit
      },
      {
        path: 'blog/records/create',
        name: 'blog-record-create',
        component: BlogRecordsCreate
      },

      // Press
      {
        path: 'press',
        name: 'press',
        component: PressList
      },
      {
        path: 'press/:pressId/edit',
        name: 'press-edit',
        component: PressEdit
      },
      {
        path: 'press/create',
        name: 'press-create',
        component: PressCreate
      },

      // Teammates
      {
        path: 'teammates',
        name: 'teammates',
        component: TeammatesList
      },
      {
        path: 'teammates/:teammateId/edit',
        name: 'teammates-edit',
        component: TeammatesEdit
      },
      {
        path: 'teammates/create',
        name: 'teammates-create',
        component: TeammatesCreate
      },

      // Testimonials
      {
        path: 'testimonials',
        name: 'testimonials',
        component: TestimonialsList
      },
      {
        path: 'testimonials/:testimonialId/edit',
        name: 'testimonials-edit',
        component: TestimonialsEdit
      },
      {
        path: 'testimonials/create',
        name: 'testimonials-create',
        component: TestimonialsCreate
      },

      // Careers
      {
        path: 'careers',
        name: 'careers',
        component: CareersList
      },
      {
        path: 'careers/:careerId/edit',
        name: 'careers-edit',
        component: CareersEdit
      },
      {
        path: 'careers/create',
        name: 'careers-create',
        component: CareersCreate
      },

      // Catalogue
      {
        path: 'catalogue/types',
        name: 'catalogue-types',
        component: CatalogueTypesList
      },
      {
        path: 'catalogue/types/:typeId/edit',
        name: 'catalogue-type-edit',
        component: CatalogueTypesEdit
      },
      {
        path: 'catalogue/types/create',
        name: 'catalogue-type-create',
        component: CatalogueTypesCreate
      },
      {
        path: 'catalogue/products',
        name: 'catalogue-products',
        component: CatalogueProductsList
      },
      {
        path: 'catalogue/products/:productId/edit',
        name: 'catalogue-product-edit',
        component: CatalogueProductsEdit
      },
      {
        path: 'catalogue/products/create',
        name: 'catalogue-product-create',
        component: CatalogueProductsCreate
      },
      {
        path: 'catalogue/strength',
        name: 'catalogue-strength',
        component: CatalogueStrengthList
      },
      {
        path: 'catalogue/strength/:strengthId/edit',
        name: 'catalogue-strength-edit',
        component: CatalogueStrengthEdit
      },
      {
        path: 'catalogue/strength/create',
        name: 'catalogue-strength-create',
        component: CatalogueStrengthCreate
      },
      {
        path: 'catalogue/flavors',
        name: 'catalogue-flavors',
        component: CatalogueFlavorsList
      },
      {
        path: 'catalogue/flavors/:flavorId/edit',
        name: 'catalogue-flavors-edit',
        component: CatalogueFlavorsEdit
      },
      {
        path: 'catalogue/flavors/create',
        name: 'catalogue-flavors-create',
        component: CatalogueFlavorsCreate
      },
      {
        path: 'catalogue/drug-forms',
        name: 'catalogue-drug-forms',
        component: CatalogueDrugFormsList
      },
      {
        path: 'catalogue/drug-forms/:formId/edit',
        name: 'catalogue-drug-forms-edit',
        component: CatalogueDrugFormsEdit
      },
      {
        path: 'catalogue/drug-forms/create',
        name: 'catalogue-drug-forms-create',
        component: CatalogueDrugFormsCreate
      },

      // Prescriptions
      {
        path: 'prescriptions',
        name: 'prescriptions',
        component: PrescriptionsList
      },
      {
        path: 'prescriptions/create',
        name: 'prescriptions-create',
        component: PrescriptionsCreate
      },
      {
        path: 'prescriptions/:prescriptionId',
        name: 'prescriptions-view',
        component: PrescriptionsView
      },

      // Teammates
      {
        path: 'profiles',
        name: 'profiles',
        component: ProfilesList
      },
      {
        path: 'profiles/:profileId/edit',
        name: 'profiles-edit',
        component: ProfilesEdit
      },
      {
        path: 'profiles/create',
        name: 'profiles-create',
        component: ProfilesCreate
      },

      // Users
      {
        path: 'accounts/users',
        name: 'accounts-users',
        component: UsersList
      },
      {
        path: 'accounts/users/:userId/edit',
        name: 'users-edit',
        component: UsersEdit
      },
      {
        path: 'accounts/users/create',
        name: 'users-create',
        component: UsersCreate
      },
      {
        path: 'accounts/roles',
        name: 'accounts-roles',
        component: RolesList
      },
      {
        path: 'accounts/roles/:roleId/edit',
        name: 'roles-edit',
        component: RolesEdit
      },
      {
        path: 'accounts/roles/create',
        name: 'roles-create',
        component: RolesCreate
      },

      // Forms
      {
        path: 'forms',
        name: 'forms',
        component: FormsList
      },
      {
        path: 'forms/:formId',
        name: 'forms-view',
        component: FormsView
      },

      // Trash
      {
        path: 'trash',
        component: TrashView
      },

      // Settings
      {
        path: 'settings',
        component: Settings
      },

      // SEO
      {
        path: 'seo/pages-meta',
        name: 'seo-pages-meta',
        component: SeoList
      },
      {
        path: 'seo/pages-meta/:seoId',
        name: 'seo-edit',
        component: SeoEdit
      },
      {
        path: 'seo/blog-category-meta',
        name: 'seo-blog-category-meta',
        component: BlogCategoriesSeoList
      },
      {
        path: 'seo/blog-category-meta/:categoryId/edit',
        name: 'blog-seo-category-edit',
        component: BlogCategoriesSeoEdit
      },
      {
        path: 'seo/blog-record-meta',
        name: 'seo-blog-record-meta',
        component: BlogRecordsSeoList
      },
      {
        path: 'seo/blog-record-meta/:recordId/edit',
        name: 'blog-seo-record-edit',
        component: BlogRecordsSeoEdit
      },
      {
        path: 'seo/categories-meta',
        name: 'seo-categories-meta',
        component: CatalogueTypesSeoList
      },
      {
        path: 'seo/categories-meta/:typeId/edit',
        name: 'catalogue-seo-type-edit',
        component: CatalogueTypesSeoEdit
      },
      {
        path: 'seo/products-meta',
        name: 'seo-products-meta',
        component: CatalogueProductsSeoList
      },
      {
        path: 'seo/products-meta/:productId/edit',
        name: 'catalogue-seo-product-edit',
        component: CatalogueProductsSeoEdit
      },
      {
        path: 'seo/images',
        name: 'seo-images',
        component: ImagesSeoList
      },
      {
        path: 'seo/images/:imageId/edit',
        name: 'seo-image-edit',
        component: ImagesSeoEdit
      },

      // Promo
      {
        path: 'promo',
        name: 'promo',
        component: PromoList
      },
      {
        path: 'promo/:promoId/edit',
        name: 'promo-edit',
        component: PromoEdit
      },
      {
        path: 'promo/create',
        name: 'promo-create',
        component: PromoCreate
      }
    ]
  },

  /*
   |--------------------------------------------------------------------------
   | Auth & Registration Routes
   |--------------------------------------------------------------------------|
   */

  {
    path: '/',
    component: LayoutLogin,
    children: [
      {
        path: 'login',
        component: Login,
        name: 'login'
      }
    ]
  },

  //  DEFAULT ROUTE
  { path: '*', component: NotFoundPage }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  //  If the next route is requires user to be Logged IN
  if (to.matched.some(m => m.meta.requiresAuth)) {
    return AuthService.check().then(authenticated => {
      if (!authenticated) {
        return next({ path: '/login' })
      }

      return next()
    })
  }

  return next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

export default router
